import React from "react";
import "../styles/about.css";
import financeImage1 from "../assets/finiance-icon-01.png";
import financeImage2 from "../assets/finiance-icon-02.png";
import financeImage3 from "../assets/finiance-icon-03.png";
import portraitImage1 from "../assets/portraits-circle-small-1.png";
import portraitImage2 from "../assets/portraits-circle-small-2.png";
import portraitImage3 from "../assets/portraits-circle-small-3.png";
import portraitImage4 from "../assets/portraits-circle-small-4.png";
import tradingImage1 from "../assets/edited1.png";
import tradingImage2 from "../assets/edited2.png";

export default function About() {
  return (
    <>
      <div className="bg-first-segment">
        <div className="container">
          <div className="row my-5">
            <div className="col center-text-col">
              <h1>About Us</h1>
              <p>
                TradeMaster is a project done be Research Group AMI Group Led by
                Prof Bo An, delicated to make use of Reinforced Learning to
                perform High Frequency Trade.
              </p>
            </div>
            <div className="col center-image">
              <img src={tradingImage2} id="trading-img1" alt="tradingImage" />
            </div>
          </div>
          <div className="row">
            <div className="col feature-box">
              <img
                src={financeImage1}
                className="about-us-icon"
                alt="finance-img1"
              />
              <h5>Security</h5>
              <p>Strong Security when using our services</p>
            </div>
            <div className="col feature-box">
              <img
                src={financeImage2}
                className="about-us-icon"
                alt="finance-img2"
              />
              <h5>Safe and reliable</h5>
              <p>
                {" "}
                The reinforced learning algorithms are rigorously tested so
                agent will make the most profitable trades
              </p>
            </div>
            <div className="col feature-box">
              <img
                src={financeImage3}
                className="about-us-icon"
                alt="finance-img3"
              />
              <h5>Earned Profits</h5>
              <p>
                With our reinforced learning model, the agent will make the most
                optimal decision
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-second-segment">
        <div className="container">
          <div className="row">
            <div className="col">
              <img src={tradingImage1} id="trading-img2" alt="tradingImage" />
            </div>
            <div className="col right-col-flex">
              <div className="text-quote">
                "Best Trading Service i had ever used, the service is fast and
                great customer service!"
              </div>
              <p className="text-ref">
                <strong>Johnathan Jacob, </strong>
                Director Lemon Finance
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-third-segment">
        <div className="container">
          <div className="row my-5">
            <div className="col-5 center-text">
              <h2>A Team of Experts Behind the Wheel</h2>
            </div>
            <div className="col offset-1">
              <div className="">
                <p>
                  The team are working very hard to produce reinforced
                  algorithms everyday. Each team member have an important part
                  to contribute.
                </p>
                <p>
                  Each of our team members are very experienced in the finance
                  and trading field industry.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col feature-box ">
              <img
                src={portraitImage1}
                className="portrait-img"
                alt="portraitImage"
              />
              <span>Shola Akinlade</span>
              <p>CEO, Founder</p>
            </div>
            <div className="col feature-box">
              <img
                src={portraitImage2}
                className="portrait-img"
                alt="portraitImage"
              />
              <span>Shola Akinlade</span>
              <p>CTO, Founder</p>
            </div>
            <div className="col feature-box">
              <img
                src={portraitImage3}
                className="portrait-img"
                alt="portraitImage"
              />
              <span>Shola Akinlade</span>
              <p>COO, Founder</p>
            </div>
            <div className="col feature-box">
              <img
                src={portraitImage4}
                className="portrait-img"
                alt="portraitImage"
              />
              <span>Shola Akinlade</span>
              <p>CFO, Founder</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
